export const OnboardTypes = [
    {key:"vendor",label:"Vendor"},
    {key:"dealer",label:"Dealer"},
];

export const RatingAgency = [
    {key:"crisil",label:"Crisil"},
    {key:"care",label:"Care"},
    {key:"icra",label:"Icra"},
    {key:"acurit-smera",label:"Acurit/SMERA"},
    {key:"india-rating",label:"India Rating"},
    {key:"info-metrics",label:"Info Metrics"},
    {key:"flitch",label:"Flitch"},
    {key:"equifax",label:"Equifax"},
    {key:"brick Works",label:"Brick Works"},
    {key:"omicra",label:"Omicra"},
];

export const industry = [
    {key:"indv",label:"Individual"},
    {key:"llp",label:"LLP"},
    {key:"ppc",label:"Private Limited"},
    {key:"prop",label:"Proprietorship"},
    {key:"gp",label:"Partnership"}
];
export const bankNames = [
    {key:"Axis Bank",label:"Axis Bank"},
    {key:"ICICI Bank",label:"ICICI Bank"},
    {key:"SBI",label:"SBI"},
    {key:"INDUSLAND",label:"INDUSLAND"},
    {key:"UNION",label:"UNION"},
    {key:"KARNATAKA",label:"KARNATAKA"},
    {key:"BANK OF BARODA",label:"BANK OF BARODA"}
]
export const companyNames = [
    'Company1',
    'Company2',
    'Company3',
]
export const productTypes = [
    'Sale_bill_discount'
]
export const turnOver = [
    '10-100 Cr',
    '100-1500 Cr',
    '> 1500 Cr'
]
export const Tenor = [
    {key:'3',label:'3 Months'},
    {key:'6',label:'6 Months'},
    {key:'12',label:'1 Yr'}
]
export const BankList = [
    'Axis Bank'
]
export const AccountTypes = [
    {key:"CC/OD",label:"CC/OD"},
    {key:"CA",label:"CA"},
    {key:"TL",label:"Term Loan"},
    {key:"PBD",label:"Purchase Bill Discount"},
    {key:"SBD",label:"Sale Bill Discount"}
]

export const LoanTypes = [
    {key:"CC/OD",label:"CC/OD"},
    {key:"TL",label:"Term Loan"},
]

export const LoanPaymentFrequency = [
    {key:"Monthly",label:"Monthly"},
    {key:"Quarterly",label:"Quarterly"},
    {key:"HalfYearly",label:"Half Yearly"},
    {key:"Yearly",label:"Yearly"},
]

export const MonthYear = [
    'Jan 2022',
    'Feb 2022',
    'Mar 2022',
    'Apr 2022',
    'May 2022',
    'Jun 2022',
    'Jul 2022',
    'Aug 2022',
    'Sep 2022',
    'Oct 2022',
    'Nov 2022',
    'Dec 2022'
]
export const leadLists = [
    'lead1',
    'lead2',
    'lead3',
]

export const status = ["APPROVED", "PENDING", "DECLINED"];

export const iconClasses = {
    APPROVED: "text-success",
    PENDING: "text-info",
    DECLINED: "text-danger",
};

export const genderCode = { "Male": "M", "Female": "F", "Others": "O" }
export const genderMaps = { "M": "Male", "F": "Female", "O": "Others" }

export const fundUsageTypes = ["Expansion"]


export const docTypes = ["A","B","C"];